export default "__VITE_PUBLIC_ASSET__804053c8__"